import { ArticleMenu } from '../../enums/article/article-menu';
import { Article } from './article';

export declare class ArticlePage extends Article {
  public menu: ArticleMenu;
  public searchable: boolean;
  public title: string;
}
